<script lang="ts">
  import type { RecommendationProduct } from "../../../interfaces/RecommendationProduct"

  import Text from "../../Common/Text.svelte"

  export let product: RecommendationProduct
</script>

<Text class="product-description">
  {@html product.description}
</Text>
